<template>
	<fieldset id="fs-equipment-selection" class="pt-3 pb-3">
		<div class="container pt-5 pb-3">
			<div class="row no-gutters">
				<div class="fieldset-title">
					<UseIcon asset="sprite.svg#icon-gears" />

					<h2 class="heading">Equipment Selection</h2>
				</div>
			</div>

			<div class="row justify-content-start no-gutters">
				<div
					v-if="!isMultipassSchematic"
					class="col-4 mr-5"
				>
					<HPWHModelSelect
						:value="formData.HPWHModelSP"
						@change="e => formData.HPWHModelSP = e.target.value"
						fieldWrapClass="size-big"
						:error="sizerStore.errors && sizerStore.errors.HPWHModelSP && sizerStore.errors.HPWHModelSP[0]"
					/>
				</div>

				<div
					v-if="isMultipassSchematic"
					class="col-4 field-wrap size-big"
				>
						<HPWHModelSelect
							:value="formData.HPWHModelMP"
							@change="e => formData.HPWHModelMP = e.target.value"
							:multipass="true"
							fieldWrapClass="size-big"
						/>
				</div>

				<div
					v-if="formData.schematic === 'paralleltank'"
					class="col-4 field-wrap size-big"
				>
						<HPWHModelSelect
							:value="formData.tmHpwhSelection"
							@change="e => formData.tmHpwhSelection = e.target.value"
							:multipass="true"
							fieldWrapClass="size-big"
						>
							<template v-slot:label>
								<label>Temperature Maintenance HPWH</label>
							</template>
						</HPWHModelSelect>
				</div>
			</div>

			<div class="row justify-content-start no-gutters" style="height: 200px">
				<div class="col-3">
					<FormInput dataKey="numberPrimHPWH" fieldWrapClass="size-big h-100" inputClass="field-icon mt-auto" />
				</div>

				<div v-if="formData.schematic === 'paralleltank'" class="col-3">
					<FormInput
						dataKey="tmNumheatPumps"
						fieldWrapClass="size-big h-100"
						inputClass="field-icon mt-auto"
					/>
				</div>

				<div class="col-3">
					<FormInput dataKey="primaryStorageVol" fieldWrapClass="size-big h-100" inputClass="field-icon mt-auto" />
				</div>
			</div>

			<div class="row justify-content-start no-gutters" style="height: 200px">
				<div v-if="formData.schematic === 'swingtank'" class="col-3">
					<FormInput
						dataKey="swingTankElement"
						fieldWrapClass="size-big h-100"
						inputClass="field-icon mt-auto"
					/>
				</div>

				<div
					v-if="['swingtank', 'paralleltank'].includes(formData.schematic)"
					class="col-3"
				>
					<FormInput
						dataKey="tempMaintStorageVol"
						fieldWrapClass="size-big h-100"
						inputClass="field-icon mt-auto"
					/>
				</div>
			</div>
		</div>
	</fieldset>
</template>

<script>
import HPWHModelSelect from '@/components/HPWHModelSelect'
import FormInput from '@/components/FormInput'
import UseIcon from '@/components/UseIcon'
import formData from '@/components/Sizer/form-data-store'
import sizerStore from '@/components/Sizer/sizer-store'

export default {
	name: 'EquipmentSelection',

	components: {
		UseIcon,
		HPWHModelSelect,
		FormInput,
	},

	data: () => ({
		formData,
		sizerStore,
	}),

	computed: {
		isMultipassSchematic() {
			return formData.schematic.startsWith('multipass') || formData.schematic === 'mprtp'
		}
	},
}
</script>
